import { render, staticRenderFns } from "./BlockCanvas.vue?vue&type=template&id=3bf1c703&scoped=true"
import script from "./BlockCanvas.vue?vue&type=script&lang=js"
export * from "./BlockCanvas.vue?vue&type=script&lang=js"
import style0 from "./BlockCanvas.vue?vue&type=style&index=0&id=3bf1c703&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf1c703",
  null
  
)

export default component.exports